import { Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../../../../../components/Button/button";
import { LoadingBackDrop } from "../../../../../../../components/loader";
import { theme } from "../../../../../../../helpers/theme";
import { offerClientFinalAccept } from "../../../../../../../services/offers/offer-client-final-accept";
import { OfferClientFinalAcceptRequestBody } from "../../../../../../../services/offers/offer-client-final-accept/types";
import { offerClientPreAccept } from "../../../../../../../services/offers/offer-client-pre-accept";
import { OfferClientPreAcceptRequestBody } from "../../../../../../../services/offers/offer-client-pre-accept/types";
import SessionService from "../../../../../../../services/session-service";
import { url, urlClient } from "../../../../../../../utils/url";
import { StyledPopover } from "../../../../../../common-views/unlogged-dashboard/form-bar/styled-popover";

interface PreliminaryAcceptanceButtonProps {
  id_zamowienia: string;
  oferta_id: string;
  isFinalOffer?: boolean;
}

export const PreliminaryAcceptanceButton = ({
  id_zamowienia,
  oferta_id,
  isFinalOffer,
}: PreliminaryAcceptanceButtonProps) => {
  const user = SessionService.getUser();
  const isLoged = user && user.token_dostepu !== null ? true : false;

  const popover_info_preaccept: string =
    "Poniższa oferta nie jest ostateczna, będziesz mógł ją finalnie potwierdzić lub odrzucić na dalszym etapie procesu. Nasz konsultant skontaktuje się z tobą w celu omówienia szczegółów realizacji.";
  const popover_info_final_accept: string =
    "Popover info dla ostatecznej oferty... ";
  const navigate = useNavigate();

  const offerClientPreAcceptMutation = useMutation(offerClientPreAccept, {
    onSuccess: (res) => {
      SessionService.clearOrderIdentification();
      navigate(url.offerInitialAcceptance);
    },
  });

  const offerClientFinalAcceptMutation = useMutation(offerClientFinalAccept, {
    onSuccess: (res) => {
      SessionService.clearOrderIdentification();
      navigate("/");
    },
  });

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const body:
    | OfferClientPreAcceptRequestBody
    | OfferClientFinalAcceptRequestBody = {
    id_zamowienia: id_zamowienia,
    oferta_id: oferta_id,
    token: isLoged ? null : SessionService.getTokenForUnlogedClient().token,
  };
  const handleSubmit = () => {
    isFinalOffer
      ? offerClientFinalAcceptMutation.mutate(body)
      : offerClientPreAcceptMutation.mutate(body);
  };

  const open = Boolean(anchorEl);
  if (
    offerClientPreAcceptMutation.isLoading ||
    offerClientFinalAcceptMutation.isLoading
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <Container>
      <Typography
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <StyledButton
          onClick={handleSubmit}
          sx={{
            paddingTop: "21px",
            paddingBottom: "21px",
            paddingLeft: "14px",
            paddingRight: "14px",
          }}
        >
          {isFinalOffer ? "*Ostateczna akceptacja" : "*Wstępna akceptacja"}
        </StyledButton>
      </Typography>
      <StyledPopover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <InfoPopoverContentContainer>
          {isFinalOffer ? popover_info_final_accept : popover_info_preaccept}
        </InfoPopoverContentContainer>
      </StyledPopover>
    </Container>
  );
};
const Container = styled.div`
  @media (max-width: 360px) {
    display: grid;
    margin: auto;
  }
`;
const InfoPopoverContentContainer = styled.div`
  padding: 10px;
  background-color: white;
  font-family: ${theme.fonts.interMedium} !important;
  color: ${theme.colors.gray01_secondaryText};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  width: 300px;
`;
